/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import React, {Component} from 'react';

import {Redirect, withRouter} from "react-router-dom";
import { UserContext } from "../UserContext";
import {intervalIdFromParams, productIdFromParams, promoCodeFromParams} from "../helpers/BillingHelper";

class SubscribeRedirectToCart extends Component {

    static contextType = UserContext;

    render() {
        const params = this.normalizeURLSearchParams();
        const queryString = params.toString();

        return <Redirect to={`/account/subscribe/cart?${queryString}`}/>;
    }

    normalizeURLSearchParams() {
        const params = new URLSearchParams(this.props.location.search);
        const productId = productIdFromParams(params);
        const intervalId = intervalIdFromParams(params);
        let promoCode = promoCodeFromParams(params);
        if (!promoCode && params.has("promoCode")) {    // Legacy value
            promoCode = params.get("promoCode");
        }

        if (productId) params.set("product", productId.toLowerCase());
        if (intervalId) params.set("interval", intervalId.toLowerCase());
        if (promoCode) params.set("promo_code", promoCode);

        return params;
    }

}

export default withRouter(SubscribeRedirectToCart)